// import React, { useState, useEffect } from 'react';

// const Typewriter = ({ text, typingSpeed, erasingSpeed, eraseDelay }) => {
//   const [displayedText, setDisplayedText] = useState('');
//   const [isErasing, setIsErasing] = useState(false);

//   useEffect(() => {
//     let interval;
//     if (!isErasing) {
//       interval = setInterval(() => {
//         setDisplayedText(prevText => {
//           if (prevText === text) {
//             setIsErasing(true);
//             clearInterval(interval);
//             setTimeout(() => setIsErasing(false), eraseDelay);
//             return prevText;
//           }
//           return prevText + text[prevText.length];
//         });
//       }, typingSpeed);
//     } else {
//       interval = setInterval(() => {
//         setDisplayedText(prevText => {
//           if (prevText === '') {
//             clearInterval(interval);
//             return '';
//           }
//           return prevText.slice(0, -1);
//         });
//       }, erasingSpeed);
//     }

//     return () => {
//       clearInterval(interval);
//     };
//   }, [text, typingSpeed, erasingSpeed, eraseDelay, isErasing]);

//   return <h3 className="home__text sweet pz__10">{displayedText}</h3>;
// };

// export default Typewriter;
import React, { useState, useEffect, useRef, useCallback } from 'react';

const Typewriter = ({ texts, typingSpeed, erasingSpeed, eraseDelay }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isErasing, setIsErasing] = useState(false);
  const currentIndexRef = useRef(0);
  const animationFrameRef = useRef(null);
  const lastTimeRef = useRef(0);

  // Optimized animation function using requestAnimationFrame
  const animate = useCallback((currentTime) => {
    if (currentTime - lastTimeRef.current >= (isErasing ? erasingSpeed : typingSpeed)) {
      lastTimeRef.current = currentTime;
      
      if (!isErasing) {
        const currentText = texts[currentTextIndex];
        const textLength = currentText.length;
        
        if (currentIndexRef.current >= textLength) {
          setIsErasing(true);
          return;
        }
        
        setDisplayedText(currentText.substring(0, currentIndexRef.current + 1));
        currentIndexRef.current++;
      } else {
        setDisplayedText(prevText => {
          if (prevText.length === 0) {
            setIsErasing(false);
            setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
            currentIndexRef.current = 0;
            return '';
          }
          return prevText.slice(0, -1);
        });
      }
    }
    
    animationFrameRef.current = requestAnimationFrame(animate);
  }, [texts, currentTextIndex, typingSpeed, erasingSpeed, isErasing]);

  useEffect(() => {
    // Start animation
    animationFrameRef.current = requestAnimationFrame(animate);
    
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [animate]);

  // Handle erase delay
  useEffect(() => {
    if (isErasing && displayedText === '') {
      const timeout = setTimeout(() => {
        setIsErasing(false);
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        currentIndexRef.current = 0;
      }, eraseDelay);
      
      return () => clearTimeout(timeout);
    }
  }, [isErasing, displayedText, eraseDelay, texts.length]);

  return <h3 className="typewriter sweet pz__10">{displayedText}</h3>;
};

export default Typewriter;
